import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/lund")(
  heritageCityRoute({
    citySlug: "lund",
    angle:
      "I Lund möter vi forskare, läkare och grundare inom life science och tech — personer vars yrkesgärning sällan finns dokumenterad i annat än publikationer.",
    localUseCases: [
      "Dokumentation av forskargärning och yrkesliv",
      "Kunskapsöverföring i life science- och techbolag",
      "Filmad livsberättelse hemma i Lund med omnejd",
      "Grundarporträtt inför ägarskifte",
      "Släkthistoria i skånska familjer",
      "Minnesfilm till högtidsdag eller minnesstund"
    ],
  }),
);
